import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SecureYourFuture from "./sections/SecureYourFuture";
import LocationMap from "./sections/LocationMap";
import SpecializedServices from "./sections/SpecializedServices";
import OurCommitment from "./sections/OurCommitment";
import LatestNewsInterviews from "./sections/LatestNewsInterviews";
import SeeUsOnSocialMedia from "./sections/SeeUsOnSocialMedia";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetInformedNow from "./sections/GetInformedNow";
import Contact from "./sections/Contact";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SecureYourFuture />
      <LocationMap />
      <SpecializedServices />
      <OurCommitment />
      <LatestNewsInterviews />
      <SeeUsOnSocialMedia />
      <FrequentlyAskedQuestions />
      <Contact />
      <ContactUs />
      <GetInformedNow />
      <Footer />
    </div>;
}